import { render, staticRenderFns } from "./VariantSelectorTextButton.vue?vue&type=template&id=bcfd7750&"
import script from "./VariantSelectorTextButton.vue?vue&type=script&lang=ts&"
export * from "./VariantSelectorTextButton.vue?vue&type=script&lang=ts&"
import style0 from "./VariantSelectorTextButton.vue?vue&type=style&index=0&id=bcfd7750&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports